import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom'; 
import Cookies from 'universal-cookie';


const ResetPasswordM = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  console.log("id success: "+  id );  



  useEffect(() => {

  if (id===undefined)
  {
  //alert("الرابط غير صحيح يرجى استخدام ال QR الذي أخذته من ال إدارة");
  }

  }, []);

    const cookies = new Cookies();

   // cookies.set('points1smsssur', user, { path: '/' });
    
  /*
  var user_cookie= cookies.get('points1smsssur'); 
  var pass_cookie= cookies.get('points1smsssprivrw'); 
  */

  const [formData, setFormData] = useState({
    telegramCode: '',
    password: ''
  });
  const [registerData, setRegisterData] = useState({
    fullName: '',
    email: '',
    phone: '',
    age: '',
    gender: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); // ADDED: Success message state
  const [isRegistering, setIsRegistering] = useState(false);

 //
   const handleRegisterChange = (e) => {
    setRegisterData({
      ...registerData,
      [e.target.name]: e.target.value
    });
  };
//
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

  
    

    console.log('Register data:', registerData);
    // Validate passwords match
    if (registerData.password !== registerData.confirmPassword) {
      setError('كلمات المرور غير متطابقة');
      setIsLoading(false);
      return;
    }

   

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Auth/entitychangepassword', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          RandomId: id,
          Password: registerData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // MODIFIED: Use success message state instead of alert
        setSuccessMessage(`تم إنشاء حسابك بنجاح!  `);
        
    
        // Clear form and switch to login
        setRegisterData({
          fullName: '',
          email: '',
          phone: '',
          age: '',
          gender: '',
          password: '',
          confirmPassword: ''
        });
        setIsRegistering(false);

        navigate('/Entity/login');
      } else {
        setError(data.message || 'حدث خطأ في إنشاء الحساب');
      }
    } catch (err) {
      console.error('Registration error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

// 
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500 flex-center"> {/* REVERTED: Back to your original working class */}
      <div className="glass p-8 m-4 w-full max-w-md">
        <div className="text-center mb-8">
          <h1   style={{marginTop: '12px',marginBottom: '12px'}}  className="text-white text-3xl font-bold mb-2">
           تغيير كلمة السر 
          </h1>
       
        </div>

      
        <div className="mt-6 text-center space-y-3"> {/* ADDED: space-y-3 for better spacing */}
  
       
              <div>
                <label className="text-white block mb-2">كلمة المرور</label>
                <input
                  style={{ marginTop: '12px', marginBottom: '12px' }}
                  type="password"
                  name="password"
                  value={registerData.password}
                  onChange={handleRegisterChange}
                  placeholder="أدخل كلمة المرور"
                  className="input"
                  required
                />
              </div>
              
              <div>
                <label className="text-white block mb-2">تأكيد كلمة المرور</label>
                <input
                  style={{ marginTop: '12px', marginBottom: '12px' }}
                  type="password"
                  name="confirmPassword"
                  value={registerData.confirmPassword}
                  onChange={handleRegisterChange}
                  placeholder="أعد إدخال كلمة المرور"
                  className="input"
                  required
                />
              </div>

         {error && (
            <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-3">
              <p className="text-white text-sm">{error}</p>
            </div>
          )}

          <button
            type="button"
            className="btn btn-primary w-full"
            disabled={isLoading}
            onClick={handleResetPassword}  // ADDED: Reset password handler
          >
            {isLoading ? (
              <div className="flex-center gap-2"> {/* REVERTED: Back to your original working class */}
                <div className="spinner"></div>
                <span>{isRegistering ? 'جاري إنشاء الحساب...' : 'جاري ارسال لينك على التيليجرام...'}</span>
              </div>
            ) : (
                ' إعادة تعيين كلمة السر'
            )}
          </button>

        </div>

    
      </div>
    </div>
  );
};

export default ResetPasswordM;